import {SvgIconData} from '@shared_web/components/core/svg_icon';

import {TEXT_MAIN_COLOR} from '@mavismart_frontend/lib/constants';

export const icon_pencil2: SvgIconData = {
  viewBox: '0 0 18 18',
  element: (
    <path
      d="M11.6935 3.36019L14.6398 6.30647M12.9435 2.11019C13.7571 1.2966 15.0762 1.2966 15.8898 2.11019C16.7034 2.92379 16.7034 4.24288 15.8898 5.05647L4.41673 16.5296H1.50006V13.5537L12.9435 2.11019Z"
      stroke={TEXT_MAIN_COLOR}
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  ),
};
